$(function () {

  // スムーズスクロール
  $('a[href^="#"]:not(.is-popup-trigger)').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  // スマホのみ電話リンクを付与
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
    $(".tel_link").each(function () {
      var tel = $(this);
      var html = tel.html();
      var teltext = tel.text();
      var telnum = teltext.replace(/[^0-9]/g, "");
      tel.html(
        $("<a>")
          .attr("href", "tel:" + telnum)
          .append(html)
      );
    });
  }


  // アナウンスバー ポップアップを開く共通処理
  function openAnnouncementPopup(popupId) {
    const $modal = $('#' + popupId);
    if ($modal.length) {
      $modal.addClass('is-active');
      $('.shopify-section-group-header-group').css('cssText', 'z-index: initial !important;');
      $('body').css('overflow', 'hidden');
    }
  }

  // クリックで開く処理
  $(document).on('click', '.is-popup-trigger', function(e) {
    e.preventDefault();
    const popupId = $(this).data('popupId');
    openAnnouncementPopup(popupId);
  });

  // 初回訪問時にfirst-couponポップアップを自動表示
  // $(document).ready(function() {
  //   const STORAGE_KEY = 'lbt_first_coupon_shown';
  //   if (!localStorage.getItem(STORAGE_KEY)) {
  //     localStorage.setItem(STORAGE_KEY, '1');
  //     openAnnouncementPopup('first-coupon');
  //   }
  // });

  // 閉じるボタンまたは背景クリックで閉じる処理
  $(document).on('click', function(e) {
    const $target = $(e.target);
    if ($target.hasClass('announcement-popup-close') || $target.hasClass('announcement-popup-modal')) {
      const $modal = $target.closest('.announcement-popup-modal');
      if ($modal.length) {
        $modal.removeClass('is-active');
        $('.shopify-section-group-header-group').css('cssText', 'z-index: 3 !important;');
        $('body').css('overflow', '');
      }
    }
  });

  // クーポンコードのコピー処理
  $(document).on('click', '.coupon_box', function() {
    const codeText = $(this).find('.code').text();
    navigator.clipboard.writeText(codeText).then(function() {
      const $label = $('.coupon_box .label');
      const originalLabel = $label.text();
      $label.text('コピーしました').css('color', '#b31717');
      setTimeout(function() {
        $label.text(originalLabel).css('color', '');
      }, 2000);
    }).catch(function(err) {
      console.error('コピーに失敗しました', err);
    });
  });

  // // アナウンスバー ポップアップを開く処理
  // $(document).on('click', '.is-popup-trigger', function(e) {
  //   e.preventDefault();
  //   const popupId = $(this).data('popupId');
  //   const $modal = $('#' + popupId);
  //   if ($modal.length) {
  //     $modal.addClass('is-active');
  //     $('.shopify-section-group-header-group').css('cssText', 'z-index: initial !important;');
  //     $('body').css('overflow', 'hidden');
  //   }
  // });

  // // 閉じるボタンまたは背景クリックで閉じる処理
  // $(document).on('click', function(e) {
  //   const $target = $(e.target);
  //   if ($target.hasClass('announcement-popup-close') || $target.hasClass('announcement-popup-modal')) {
  //     const $modal = $target.closest('.announcement-popup-modal');
  //     if ($modal.length) {
  //       $modal.removeClass('is-active');
  //       $('.shopify-section-group-header-group').css('cssText', 'z-index: 3 !important;');
  //       $('body').css('overflow', '');
  //     }
  //   }
  // });


  // カート：購入手続きボタンクリック時に確認ポップアップを表示
  // $(document).on('click', '#checkout', function (e) {
  //   const $modal = $('#cart-checkout-confirm-modal');
  //   if ($modal.length && !$modal.hasClass('is-active')) {
  //     e.preventDefault();
  //     $modal.addClass('is-active');
  //     $('.shopify-section-group-header-group').css('cssText', 'z-index: initial !important;');
  //     $('body').css('overflow', 'hidden');
  //   }
  // });

  // 確認ポップアップの「確認した」ボタンでチェックアウトへ進む
  // $(document).on('click', '#cart-checkout-confirm-btn', function (e) {
  //   e.preventDefault();

  //   const $modal = $('#cart-checkout-confirm-modal');
  //   $modal.removeClass('is-active');
  //   $('.shopify-section-group-header-group').css('cssText', 'z-index: 3 !important;');
  //   $('body').css('overflow', '');

  //   const btnEl = document.getElementById('checkout');
  //   if (!btnEl) return;

  //   // checkoutボタンは form="cart" 属性で外部フォームと紐づいているため、
  //   // getAttribute('form') のIDからフォーム本体を取得する
  //   const formId = btnEl.getAttribute('form');
  //   const formEl = formId ? document.getElementById(formId) : btnEl.closest('form');
  //   if (!formEl) return;

  //   if (typeof formEl.requestSubmit === 'function') {
  //     // requestSubmitにボタンをsubmitterとして渡すことで
  //     // name="checkout" 付きの送信として扱われ、決済画面へ遷移する
  //     formEl.requestSubmit(btnEl);
  //   } else {
  //     // requestSubmit未対応の古いブラウザ向けフォールバック
  //     const hidden = document.createElement('input');
  //     hidden.type = 'hidden';
  //     hidden.name = 'checkout';
  //     hidden.value = '';
  //     formEl.appendChild(hidden);
  //     formEl.submit();
  //   }
  // });

  // // クーポンコードのコピー処理
  // $(document).on('click', '.coupon_box', function() {
  //   const codeText = $(this).find('.code').text();
  //   navigator.clipboard.writeText(codeText).then(function() {
  //     const $label = $('.coupon_box .label');
  //     const originalLabel = $label.text();
  //     $label.text('コピーしました').css('color', '#b31717');
  //     setTimeout(function() {
  //       $label.text(originalLabel).css('color', '');
  //     }, 2000);
  //   }).catch(function(err) {
  //     console.error('コピーに失敗しました', err);
  //   });
  // });

  // header ナビゲーション
  $('.js-has-child').on('click', function() {
    var $targetChild = $(this).siblings('.child');
    $('.child').not($targetChild).removeClass('active');

    $targetChild.toggleClass('active');
    
    return false;
  });

  const $openBtn = $('.menu_btn');
  const $closeBtn = $('.menu_btn_close');
  const $spNav = $('.sp_nav_box');

  $openBtn.on('click', function(e) {
    e.preventDefault();
    $spNav.addClass('is-active');
    $('body').css('overflow', 'hidden');
  });

  $closeBtn.on('click', function(e) {
    e.preventDefault();
    $spNav.removeClass('is-active');
    $('body').css('overflow', '');
  });

  $('.sp_nav_box a').on('click', function() {
    $spNav.removeClass('is-active');
    $('body').css('overflow', '');
  });


  ////////////////////////////////////
  // TOPページ
  ////////////////////////////////////

  // FVスライダー
  if ($(".fv_slider").length) {
    const fv_swiper = new Swiper(".fv_slider", {
      effect: "fade",
      crossFade: true,
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  }

  // ブランド一覧
  if ($(".pc_brands_list").length) {
    $(window).scroll(function () {
      $('.pc_brands_list .contents > div').each(function () {
        boxNum = $(this).attr("class"),
        scrollTop = $(window).scrollTop();
        areaTop = $(this).offset().top - 300;
        if (scrollTop > areaTop) {
          $('.images .' + boxNum).addClass('active');
        } else {
          $('.images .' + boxNum).removeClass('active');
        }
      });
    });
  }


  // メディア スライダー
  if ($(".am_slider").length) {
    const news_swiper = new Swiper(".am_slider", {
      loop: true,
      speed: 3000,
      allowTouchMove: false,
      slidesPerView: 'auto',
      spaceBetween: 30,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: false,
      },
      breakpoints: {
        768: { 
          spaceBetween: 40,
          speed: 4000,
        },
        1024: { 
          spaceBetween: 70,
          speed: 5000,
         },
      },
    });
  }

  // お知らせ スライダー
  // if ($(".news_slider").length) {
  //   const speed = 6000;

  //   const news_swiper = new Swiper(".news_slider", {
  //     loop: true,
  //     speed: speed,
  //     allowTouchMove: false,
  //     slidesPerView: 'auto',
  //     spaceBetween: 20,
  //     autoplay: {
  //       delay: 0,
  //       disableOnInteraction: false,
  //       reverseDirection: true,
  //     },
  //     breakpoints: {
  //       768: { spaceBetween: 30 },
  //     },
  //   });

  //   const sliderEl = document.querySelector(".news_slider");

  //   sliderEl.addEventListener("mouseenter", () => {
  //     // 現在位置でその場に固定
  //     const currentTranslate = news_swiper.getTranslate();
  //     news_swiper.setTranslate(currentTranslate);
  //     news_swiper.setTransition(0);
  //   });

  //   sliderEl.addEventListener("mouseleave", () => {
  //     const currentTranslate = news_swiper.getTranslate();

  //     const activeSlide = document.querySelector(".news_slider .swiper-slide-active");
  //     const mgLeft = parseFloat(activeSlide.style.marginLeft) || 0;
  //     const mgRight = parseFloat(activeSlide.style.marginRight) || 0;
  //     const slideWidth = activeSlide.offsetWidth;
  //     const totalSlideWidth = slideWidth + mgLeft + mgRight;

  //     // reverseDirection: true なので translate は「増加」方向に進む想定
  //     const diff = totalSlideWidth - (currentTranslate % totalSlideWidth);
  //     const diffTime = diff / slideWidth;

  //     news_swiper.setTranslate(currentTranslate + diff);
  //     news_swiper.setTransition(speed * diffTime);
  //   });
  // }

  // お買い物はこちら スライダー
  if ($(".left_right_store_slider").length) {
    const store_swiper = new Swiper(".left_right_store_slider", {
      loop: true,
      speed: 4000,
      allowTouchMove: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      breakpoints: {
        768: { spaceBetween: 0 },
      },
    });
  }
  if ($(".right_left_store_slider").length) {
    const store_swiper = new Swiper(".right_left_store_slider", {
      loop: true,
      speed: 4000,
      allowTouchMove: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: false,
      },
      breakpoints: {
        768: { spaceBetween: 0 },
      },
    });
  }

  // lookbook スライダー
  if ($(".lookbook_slider").length) {
    const lookbook_swiper = new Swiper('.lookbook_slider', {
      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: false,
      loop: true,
      breakpoints: {
        1024: { slidesPerView: 3.5, spaceBetween: 30 },
        768:  { slidesPerView: 2.5, spaceBetween: 20 },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // lookbook スポットボタンのクリック動作
  $('.spot_btn').on('click', function(e) {
    e.stopPropagation();
    const $popup = $(this).next('.spot_popup');
    const isActive = $(this).hasClass('is-active');
    $('.spot_popup').hide();
    $('.spot_btn').removeClass('is-active');
    if (!isActive) {
      $popup.show();
      $(this).addClass('is-active');
    }
  });

  $(document).on('click', function() {
    $('.spot_popup').hide();
    $('.spot_btn').removeClass('is-active');
  });

  $('.spot_popup').on('click', function(e) {
    e.stopPropagation();
  });


  // ブランドページ ユーザーレビュー スライダー
  if ($(".review_slider").length) {
    const review_swiper = new Swiper('.review_slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        1024: { slidesPerView: 1.8, spaceBetween: 80 },
        768:  { slidesPerView: 1.3, spaceBetween: 40 },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          setNavButtonPosition_review($('.review_slider'));
        },
        resize: function () {
          setNavButtonPosition_review($('.review_slider'));
        }
      }
    });
  }

  function setNavButtonPosition_review(sliderEl) {
    if (!window.matchMedia('(max-width: 750px)').matches) {
      //PC時
      const activeSlidePosLeft = sliderEl
        .find('.swiper-slide-active')
        .offset().left; //画面左端からアクティブスライドの左端までの距離
      const nextSlidePosLeft = sliderEl
        .find('.swiper-slide-next')
        .offset().left; //画面左端からNextスライドの左端までの距離
      const navBtnWidth = sliderEl
        .find('.swiper-button-next')
        .outerWidth(); //Navボタンの幅
      const offset = Math.floor(
        (nextSlidePosLeft - activeSlidePosLeft + navBtnWidth) / 2
      );

      sliderEl.find('.swiper-button-prev').css({
        left: 'calc(50% - ' + offset + 'px)'
      }); //prevボタンの位置を設定
      sliderEl.find('.swiper-button-next').css({
        right: 'calc(50% - ' + offset + 'px)'
      }); //nextボタンの位置を設定
    } else {
      // SP時、style削除
      sliderEl.find('.swiper-button-next').removeAttr('style');
      sliderEl.find('.swiper-button-prev').removeAttr('style');
    }
  }


  ////////////////////////////////////
  // 商品一覧
  ////////////////////////////////////
  //********************** */
  // カード カラースウォッチ
  //********************** */

  ////////////////////
  // ver01
  ////////////////////
  // const CardColorSwatch = (() => {

  //   // タクソノミーID → グループに属する個別カラー名（バリアント名と完全一致）
  //   const TAXONOMY_COLOR_MAP = {
  //     'gid://shopify/TaxonomyValue/1':  ['アッシュグレー', 'アルミニウムブラック', 'ブラック', 'マットブラック'],
  //     'gid://shopify/TaxonomyValue/3':  ['エナメルホワイト', 'ホワイト', 'マットホワイト', 'アイボリーホワイト'],
  //     'gid://shopify/TaxonomyValue/5':  ['アルミニウムシルバー', 'エナメルシルバー', 'グレー', 'シルバー', 'マットグレー', 'マットシルバー', 'スモーキーグレー', 'ダークグレー'],
  //     'gid://shopify/TaxonomyValue/11': ['エナメルピンク', 'コーラルピンク', 'ピンク'],
  //     'gid://shopify/TaxonomyValue/2':  ['エナメルスカイブルー', 'ブルー', 'スカイブルー'],
  //     'gid://shopify/TaxonomyValue/9':  ['エナメルカーキ', 'オリーブ'],
  //     'gid://shopify/TaxonomyValue/12': ['パープル', 'ラベンダーパープル'],
  //     'gid://shopify/TaxonomyValue/7':  ['ブラウン'],
  //     'gid://shopify/TaxonomyValue/6':  ['サンドベージュ', 'ベージュ'],
  //   };

  //   const COLOR_MAP = {
  //     'ブラック': '#111111', '黒': '#111111',
  //     'ホワイト': '#ffffff', '白': '#ffffff',
  //     'レッド':   '#c0392b', '赤': '#c0392b',
  //     'オレンジ': '#e67e22',
  //     'グリーン': '#27ae60', '緑': '#27ae60',
  //     'ネイビー': '#1a2a4a',
  //     'グレー':   '#95a5a6', 'グレイ': '#95a5a6',
  //     'ベージュ': '#d4b896',
  //     'ブルー':   '#2980b9', '青': '#2980b9',
  //     'ピンク':   '#e91e8c',
  //     'パープル': '#8e44ad',
  //     'イエロー': '#f1c40f', '黄': '#f1c40f',
  //     'ブラウン': '#795548', '茶': '#795548',
  //     'シルバー': '#b0bec5',
  //     'ゴールド': '#ffd700',
  //     'black':  '#111111', 'white':  '#ffffff',
  //     'red':    '#c0392b', 'orange': '#e67e22',
  //     'green':  '#27ae60', 'navy':   '#1a2a4a',
  //     'gray':   '#95a5a6', 'grey':   '#95a5a6',
  //     'beige':  '#d4b896', 'blue':   '#2980b9',
  //     'pink':   '#e91e8c', 'purple': '#8e44ad',
  //     'yellow': '#f1c40f', 'brown':  '#795548',
  //     'silver': '#b0bec5', 'gold':   '#ffd700',
  //   };

  //   function applyDotColor(dot) {
  //     if (dot.style.backgroundColor && dot.style.backgroundColor !== 'rgb(204, 204, 204)') return;
  //     const name  = dot.dataset.colorName || '';
  //     const color = COLOR_MAP[name] || COLOR_MAP[name.toLowerCase()];
  //     if (color) dot.style.backgroundColor = color;
  //   }

  //   function init() {
  //     document.querySelectorAll('.card__color-dot').forEach(applyDotColor);

  //     // URLの color-pattern パラメータからタクソノミーIDを取得し
  //     // 対応する個別カラー名のセットを作成
  //     const params = new URLSearchParams(window.location.search);
  //     const activeGroupColors = new Set();
  //     params.forEach((value, key) => {
  //       if (key.includes('color-pattern')) {
  //         const colors = TAXONOMY_COLOR_MAP[value];
  //         if (colors) {
  //           colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
  //         }
  //       }
  //       // active_color フォールバック（個別カラー名が直接入っている場合）
  //       if (key === 'active_color') {
  //         const colors = TAXONOMY_COLOR_MAP[value];
  //         if (colors) {
  //           colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
  //         } else {
  //           activeGroupColors.add(value.toLowerCase());
  //         }
  //       }
  //     });

  //     document.querySelectorAll('.card__color-swatches').forEach((swatches) => {
  //       let matched = false;

  //       if (activeGroupColors.size > 0) {
  //         swatches.querySelectorAll('.card__color-swatch').forEach((btn) => {
  //           const colorName = (btn.dataset.color || '').toLowerCase();
  //           if (activeGroupColors.has(colorName)) {
  //             btn.classList.add('is-active');
  //             const imageUrl = btn.dataset.variantImage;
  //             if (imageUrl) {
  //               const cardWrapper = btn.closest('.card-wrapper');
  //               if (cardWrapper) {
  //                 const img = cardWrapper.querySelector('.card__media img');
  //                 if (img) {
  //                   img.src = imageUrl;
  //                   img.srcset = imageUrl;
  //                 }
  //               }
  //             }
  //             matched = true;
  //           }
  //         });
  //       }

  //       if (!matched) {
  //         const first = swatches.querySelector('.card__color-swatch');
  //         if (first) first.classList.add('is-active');
  //       }
  //     });
  //   }

  //   function select(btn, event) {
  //     if (event) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //     }

  //     const imageUrl = btn.dataset.variantImage;

  //     const swatchesContainer = btn.closest('.card__color-swatches');
  //     if (swatchesContainer) {
  //       swatchesContainer.querySelectorAll('.card__color-swatch').forEach((el) => {
  //         el.classList.remove('is-active');
  //       });
  //       btn.classList.add('is-active');
  //     }

  //     if (!imageUrl) return;
  //     const cardWrapper = btn.closest('.card-wrapper');
  //     if (!cardWrapper) return;
  //     const img = cardWrapper.querySelector('.card__media img');
  //     if (!img) return;

  //     img.src = imageUrl;
  //     img.srcset = imageUrl;
  //   }

  //   init();
  //   return { select };
  // })();

  ////////////////////
  // ver02
  ////////////////////
  // const CardColorSwatch = (() => {
 
  //   // タクソノミーID → グループに属する個別カラー名（バリアント名と完全一致）
  //   const TAXONOMY_COLOR_MAP = {
  //     'gid://shopify/TaxonomyValue/1':  ['アッシュグレー', 'アルミニウムブラック', 'ブラック', 'マットブラック'],
  //     'gid://shopify/TaxonomyValue/3':  ['エナメルホワイト', 'ホワイト', 'マットホワイト', 'アイボリーホワイト'],
  //     'gid://shopify/TaxonomyValue/5':  ['アルミニウムシルバー', 'エナメルシルバー', 'グレー', 'シルバー', 'マットグレー', 'マットシルバー', 'スモーキーグレー', 'ダークグレー'],
  //     'gid://shopify/TaxonomyValue/11': ['エナメルピンク', 'コーラルピンク', 'ピンク'],
  //     'gid://shopify/TaxonomyValue/2':  ['エナメルスカイブルー', 'ブルー', 'スカイブルー'],
  //     'gid://shopify/TaxonomyValue/9':  ['エナメルカーキ', 'オリーブ'],
  //     'gid://shopify/TaxonomyValue/12': ['パープル', 'ラベンダーパープル'],
  //     'gid://shopify/TaxonomyValue/7':  ['ブラウン'],
  //     'gid://shopify/TaxonomyValue/6':  ['サンドベージュ', 'ベージュ'],
  //   };
 
  //   const COLOR_MAP = {
  //     'ブラック': '#111111', '黒': '#111111',
  //     'ホワイト': '#ffffff', '白': '#ffffff',
  //     'レッド':   '#c0392b', '赤': '#c0392b',
  //     'オレンジ': '#e67e22',
  //     'グリーン': '#27ae60', '緑': '#27ae60',
  //     'ネイビー': '#1a2a4a',
  //     'グレー':   '#95a5a6', 'グレイ': '#95a5a6',
  //     'ベージュ': '#d4b896',
  //     'ブルー':   '#2980b9', '青': '#2980b9',
  //     'ピンク':   '#e91e8c',
  //     'パープル': '#8e44ad',
  //     'イエロー': '#f1c40f', '黄': '#f1c40f',
  //     'ブラウン': '#795548', '茶': '#795548',
  //     'シルバー': '#b0bec5',
  //     'ゴールド': '#ffd700',
  //     'black':  '#111111', 'white':  '#ffffff',
  //     'red':    '#c0392b', 'orange': '#e67e22',
  //     'green':  '#27ae60', 'navy':   '#1a2a4a',
  //     'gray':   '#95a5a6', 'grey':   '#95a5a6',
  //     'beige':  '#d4b896', 'blue':   '#2980b9',
  //     'pink':   '#e91e8c', 'purple': '#8e44ad',
  //     'yellow': '#f1c40f', 'brown':  '#795548',
  //     'silver': '#b0bec5', 'gold':   '#ffd700',
  //   };
 
  //   // カラーカスタムキット名 → アクセントカラー。
  //   // ここに無い値（「なし(ブラック)」等）は単色のまま表示する。
  //   const KIT_COLOR_MAP = {
  //     'オレンジ': '#e67e22',
  //     'グリーン': '#27ae60',
  //   };
 
  //   function resolveBaseColor(dot) {
  //     let color = dot.style.backgroundColor;
  //     const isUnset = !color || color === 'rgb(204, 204, 204)' || color === '#ccc';
  //     if (isUnset) {
  //       const name = dot.dataset.colorName || '';
  //       color = COLOR_MAP[name] || COLOR_MAP[name.toLowerCase()] || color;
  //     }
  //     return color;
  //   }
 
  //   // ドットの背景を「カラー」単色、または「カラー × カラーカスタムキット」の
  //   // 斜め2色分割で描画する
  //   function applyDotColor(dot) {
  //     const btn = dot.closest('.card__color-swatch');
  //     const kitName = btn ? (btn.dataset.kit || '') : '';
  //     const kitColor = KIT_COLOR_MAP[kitName];
  //     const baseColor = resolveBaseColor(dot);
 
  //     if (kitColor && baseColor) {
  //       dot.style.backgroundColor = '';
  //       dot.style.background = `linear-gradient(135deg, ${baseColor} 50%, ${kitColor} 50%)`;
  //     } else if (baseColor) {
  //       dot.style.background = '';
  //       dot.style.backgroundColor = baseColor;
  //     }
  //   }
 
  //   function init() {
  //     document.querySelectorAll('.card__color-dot').forEach(applyDotColor);
 
  //     // URLの color-pattern パラメータからタクソノミーIDを取得し
  //     // 対応する個別カラー名のセットを作成
  //     const params = new URLSearchParams(window.location.search);
  //     const activeGroupColors = new Set();
  //     params.forEach((value, key) => {
  //       if (key.includes('color-pattern')) {
  //         const colors = TAXONOMY_COLOR_MAP[value];
  //         if (colors) {
  //           colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
  //         }
  //       }
  //       // active_color フォールバック（個別カラー名が直接入っている場合）
  //       if (key === 'active_color') {
  //         const colors = TAXONOMY_COLOR_MAP[value];
  //         if (colors) {
  //           colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
  //         } else {
  //           activeGroupColors.add(value.toLowerCase());
  //         }
  //       }
  //     });
 
  //     document.querySelectorAll('.card__color-swatches').forEach((swatches) => {
  //       let matched = false;
 
  //       if (activeGroupColors.size > 0) {
  //         const buttons = Array.from(swatches.querySelectorAll('.card__color-swatch'));
  //         for (const btn of buttons) {
  //           const colorName = (btn.dataset.color || '').toLowerCase();
  //           if (activeGroupColors.has(colorName)) {
  //             // 同じカラーでキット違いの複数スウォッチがあっても、
  //             // アクティブにするのは最初に一致した1件だけにする
  //             buttons.forEach((b) => b.classList.remove('is-active'));
  //             btn.classList.add('is-active');
  //             const imageUrl = btn.dataset.variantImage;
  //             if (imageUrl) {
  //               const cardWrapper = btn.closest('.card-wrapper');
  //               if (cardWrapper) {
  //                 const img = cardWrapper.querySelector('.card__media img');
  //                 if (img) {
  //                   img.src = imageUrl;
  //                   img.srcset = imageUrl;
  //                 }
  //               }
  //             }
  //             matched = true;
  //             break;
  //           }
  //         }
  //       }
 
  //       if (!matched) {
  //         const first = swatches.querySelector('.card__color-swatch');
  //         if (first) first.classList.add('is-active');
  //       }
  //     });
  //   }
 
  //   function select(btn, event) {
  //     if (event) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //     }
 
  //     const imageUrl = btn.dataset.variantImage;
 
  //     const swatchesContainer = btn.closest('.card__color-swatches');
  //     if (swatchesContainer) {
  //       swatchesContainer.querySelectorAll('.card__color-swatch').forEach((el) => {
  //         el.classList.remove('is-active');
  //       });
  //       btn.classList.add('is-active');
  //     }
 
  //     if (!imageUrl) return;
  //     const cardWrapper = btn.closest('.card-wrapper');
  //     if (!cardWrapper) return;
  //     const img = cardWrapper.querySelector('.card__media img');
  //     if (!img) return;
 
  //     img.src = imageUrl;
  //     img.srcset = imageUrl;
  //   }
 
  //   init();

  //   // 関連商品(product-recommendations)は非同期でHTMLが後から挿入されるため、
  //   // 挿入後にカラースウォッチの装飾（単色/斜め2色）とアクティブ状態を再適用する
  //   function initNewSwatches(root) {
  //     root.querySelectorAll('.card__color-dot').forEach((dot) => {
  //       if (dot.dataset.lbtSwatchInit) return;
  //       dot.dataset.lbtSwatchInit = '1';
  //       applyDotColor(dot);
  //     });
  //     root.querySelectorAll('.card__color-swatches').forEach((swatches) => {
  //       if (swatches.dataset.lbtSwatchInit) return;
  //       swatches.dataset.lbtSwatchInit = '1';
  //       if (!swatches.querySelector('.card__color-swatch.is-active')) {
  //         const first = swatches.querySelector('.card__color-swatch');
  //         if (first) first.classList.add('is-active');
  //       }
  //     });
  //   }

  //   document.querySelectorAll('product-recommendations').forEach((el) => {
  //     const observer = new MutationObserver(() => initNewSwatches(el));
  //     observer.observe(el, { childList: true, subtree: true });
  //   });
  //   return { select };
  // })();


  ////////////////////
  // ver03 20261104
  ////////////////////
  const CardColorSwatch = (() => {
 
    // タクソノミーID → グループに属する個別カラー名（バリアント名と完全一致）
    const TAXONOMY_COLOR_MAP = {
      'gid://shopify/TaxonomyValue/1':  ['アッシュグレー', 'アルミニウムブラック', 'ブラック', 'マットブラック'],
      'gid://shopify/TaxonomyValue/3':  ['エナメルホワイト', 'ホワイト', 'マットホワイト', 'アイボリーホワイト'],
      'gid://shopify/TaxonomyValue/5':  ['アルミニウムシルバー', 'エナメルシルバー', 'グレー', 'シルバー', 'マットグレー', 'マットシルバー', 'スモーキーグレー', 'ダークグレー'],
      'gid://shopify/TaxonomyValue/11': ['エナメルピンク', 'コーラルピンク', 'ピンク'],
      'gid://shopify/TaxonomyValue/2':  ['エナメルスカイブルー', 'ブルー', 'スカイブルー'],
      'gid://shopify/TaxonomyValue/9':  ['エナメルカーキ', 'オリーブ'],
      'gid://shopify/TaxonomyValue/12': ['パープル', 'ラベンダーパープル'],
      'gid://shopify/TaxonomyValue/7':  ['ブラウン'],
      'gid://shopify/TaxonomyValue/6':  ['サンドベージュ', 'ベージュ'],
    };
 
    const COLOR_MAP = {
      'ブラック': '#111111', '黒': '#111111',
      'ホワイト': '#ffffff', '白': '#ffffff',
      'レッド':   '#c0392b', '赤': '#c0392b',
      'オレンジ': '#e67e22',
      'グリーン': '#27ae60', '緑': '#27ae60',
      'ネイビー': '#1a2a4a',
      'グレー':   '#95a5a6', 'グレイ': '#95a5a6',
      'ベージュ': '#d4b896',
      'ブルー':   '#2980b9', '青': '#2980b9',
      'ピンク':   '#e91e8c',
      'パープル': '#8e44ad',
      'イエロー': '#f1c40f', '黄': '#f1c40f',
      'ブラウン': '#795548', '茶': '#795548',
      'シルバー': '#b0bec5',
      'ゴールド': '#ffd700',
      'black':  '#111111', 'white':  '#ffffff',
      'red':    '#c0392b', 'orange': '#e67e22',
      'green':  '#27ae60', 'navy':   '#1a2a4a',
      'gray':   '#95a5a6', 'grey':   '#95a5a6',
      'beige':  '#d4b896', 'blue':   '#2980b9',
      'pink':   '#e91e8c', 'purple': '#8e44ad',
      'yellow': '#f1c40f', 'brown':  '#795548',
      'silver': '#b0bec5', 'gold':   '#ffd700',
    };
 
    // カラーカスタムキット名 → アクセントカラー。
    // ここに無い値（「なし(ブラック)」等）は単色のまま表示する。
    const KIT_COLOR_MAP = {
      'オレンジ': '#e67e22',
      'グリーン': '#27ae60',
    };
 
    function resolveBaseColor(dot) {
      let color = dot.style.backgroundColor;
      const isUnset = !color || color === 'rgb(204, 204, 204)' || color === '#ccc';
      if (isUnset) {
        const name = dot.dataset.colorName || '';
        color = COLOR_MAP[name] || COLOR_MAP[name.toLowerCase()] || color;
      }
      return color;
    }
 
    // ドットの背景を「カラー」単色、または「カラー × カラーカスタムキット」の
    // 斜め2色分割で描画する
    function applyDotColor(dot) {
      const btn = dot.closest('.card__color-swatch');
      const kitName = btn ? (btn.dataset.kit || '') : '';
      const kitColor = KIT_COLOR_MAP[kitName];
      const baseColor = resolveBaseColor(dot);
 
      if (kitColor && baseColor) {
        dot.style.backgroundColor = '';
        dot.style.background = `linear-gradient(135deg, ${baseColor} 50%, ${kitColor} 50%)`;
      } else if (baseColor) {
        dot.style.background = '';
        dot.style.backgroundColor = baseColor;
      }
    }
 
    function init() {
      document.querySelectorAll('.card__color-dot').forEach(applyDotColor);
 
      // URLの color-pattern パラメータからタクソノミーIDを取得し
      // 対応する個別カラー名のセットを作成
      const params = new URLSearchParams(window.location.search);
      const activeGroupColors = new Set();
      params.forEach((value, key) => {
        if (key.includes('color-pattern')) {
          const colors = TAXONOMY_COLOR_MAP[value];
          if (colors) {
            colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
          }
        }
        // active_color フォールバック（個別カラー名が直接入っている場合）
        if (key === 'active_color') {
          const colors = TAXONOMY_COLOR_MAP[value];
          if (colors) {
            colors.forEach(c => activeGroupColors.add(c.toLowerCase()));
          } else {
            activeGroupColors.add(value.toLowerCase());
          }
        }
      });
 
      document.querySelectorAll('.card__color-swatches').forEach((swatches) => {
        let matched = false;
 
        if (activeGroupColors.size > 0) {
          const buttons = Array.from(swatches.querySelectorAll('.card__color-swatch'));
          for (const btn of buttons) {
            const colorName = (btn.dataset.color || '').toLowerCase();
            if (activeGroupColors.has(colorName)) {
              // 同じカラーでキット違いの複数スウォッチがあっても、
              // アクティブにするのは最初に一致した1件だけにする
              buttons.forEach((b) => b.classList.remove('is-active'));
              btn.classList.add('is-active');
              const imageUrl = btn.dataset.variantImage;
              if (imageUrl) {
                const cardWrapper = btn.closest('.card-wrapper');
                if (cardWrapper) {
                  const img = cardWrapper.querySelector('.card__media img');
                  if (img) {
                    img.src = imageUrl;
                    img.srcset = imageUrl;
                  }
                }
              }
              matched = true;
              break;
            }
          }
        }
 
        if (!matched) {
          const first = swatches.querySelector('.card__color-swatch');
          if (first) first.classList.add('is-active');
        }
      });
    }
 
    // ===== サイズ セレクトボックス =====
    function getVariants(cardWrapper) {
      if (cardWrapper._lbtVariants) return cardWrapper._lbtVariants;
      const el = cardWrapper.querySelector('.card__variants-json');
      let list = [];
      try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
      cardWrapper._lbtVariants = list;
      return list;
    }

    // 今アクティブなカラー（とキット）で、選んだサイズのバリエーションを探す
    function findVariant(cardWrapper, size) {
      const active = cardWrapper.querySelector('.card__color-swatch.is-active');
      const color = active ? (active.dataset.color || '') : '';
      const kit = active ? (active.dataset.kit || '') : '';
      return getVariants(cardWrapper).find((v) =>
        v.s === size && (!color || v.c === color) && (!kit || v.k === kit)
      );
    }

    // カラーに合わせて、サイズの「在庫なし」表示を更新する
    function refreshSizeOptions(cardWrapper) {
      const select = cardWrapper.querySelector('.card__size-select');
      if (!select) return;
      Array.from(select.options).forEach((opt) => {
        const v = findVariant(cardWrapper, opt.value);
        const label = opt.dataset.label || opt.value;
        opt.textContent = (v && !v.a) ? label + '（在庫なし）' : label;
        opt.disabled = !v;
      });
      // 選択中のサイズがこのカラーに無い場合は、あるサイズに切り替える
      if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
        const firstOk = Array.from(select.options).find((o) => !o.disabled);
        if (firstOk) select.value = firstOk.value;
      }
    }

    // カード内のリンクを選択中バリエーションに合わせる（商品ページでもそのサイズが開く）
    function updateLinks(cardWrapper, variant) {
      if (!variant) return;
      cardWrapper.querySelectorAll('a.full-unstyled-link').forEach((a) => {
        const base = (a.getAttribute('href') || '').split('?')[0];
        if (base) a.setAttribute('href', base + '?variant=' + variant.id);
      });
    }

    function changeSize(select, event) {
      if (event) event.stopPropagation();
      const cardWrapper = select.closest('.card-wrapper');
      if (!cardWrapper) return;
      const variant = findVariant(cardWrapper, select.value);
      if (!variant) return;
      updateLinks(cardWrapper, variant);
      if (variant.i) {
        const img = cardWrapper.querySelector('.card__media img');
        if (img) {
          img.src = variant.i;
          img.srcset = variant.i;
        }
      }
    }

    function select(btn, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      let imageUrl = btn.dataset.variantImage;

      const swatchesContainer = btn.closest('.card__color-swatches');
      if (swatchesContainer) {
        swatchesContainer.querySelectorAll('.card__color-swatch').forEach((el) => {
          el.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      }

      // カラーを変えたら、サイズの選択肢（在庫表示）も更新する
      const wrapperForSize = btn.closest('.card-wrapper');
      if (wrapperForSize) {
        refreshSizeOptions(wrapperForSize);
        const sizeSelect = wrapperForSize.querySelector('.card__size-select');
        if (sizeSelect) {
          // 選んでいるサイズ × 新しいカラーのバリエーション画像を優先する
          const picked = findVariant(wrapperForSize, sizeSelect.value);
          updateLinks(wrapperForSize, picked);
          if (picked && picked.i) imageUrl = picked.i;
        }
      }

      if (!imageUrl) return;
      const cardWrapper = btn.closest('.card-wrapper');
      if (!cardWrapper) return;
      const img = cardWrapper.querySelector('.card__media img');
      if (!img) return;
 
      img.src = imageUrl;
      img.srcset = imageUrl;
    }
 
    init();
    document.querySelectorAll('.card-wrapper').forEach(refreshSizeOptions);

    // 関連商品(product-recommendations)は非同期でHTMLが後から挿入されるため、
    // 挿入後にカラースウォッチの装飾（単色/斜め2色）とアクティブ状態を再適用する
    function initNewSwatches(root) {
      root.querySelectorAll('.card__color-dot').forEach((dot) => {
        if (dot.dataset.lbtSwatchInit) return;
        dot.dataset.lbtSwatchInit = '1';
        applyDotColor(dot);
      });
      root.querySelectorAll('.card__color-swatches').forEach((swatches) => {
        if (swatches.dataset.lbtSwatchInit) return;
        swatches.dataset.lbtSwatchInit = '1';
        const cw = swatches.closest('.card-wrapper');
        if (cw) refreshSizeOptions(cw);
        if (!swatches.querySelector('.card__color-swatch.is-active')) {
          const first = swatches.querySelector('.card__color-swatch');
          if (first) first.classList.add('is-active');
        }
      });
    }

    document.querySelectorAll('product-recommendations').forEach((el) => {
      const observer = new MutationObserver(() => initNewSwatches(el));
      observer.observe(el, { childList: true, subtree: true });
    });


    
    return { select, changeSize };
  })();






  //********************** */
  // フィルターパネル
  //********************** */

  const FilterPanel = (() => {
    const PANEL_ID     = 'FilterPanel';
    const OVERLAY_ID   = 'FilterOverlay';
    const CLOSE_BTN_ID = 'FilterCloseBtn';
    const FORM_ID      = 'FilterForm';
    const OPEN_CLASS   = 'is-open';
    const BODY_CLASS   = 'filter-panel-open';

    // カテゴリープリセット定義
    // tags: URLに送信するfilter.p.tagの値
    // children: 子カテゴリーのラベル（子が個別チェックされた場合もここで管理）
    const CATEGORY_PRESETS = {
      'シーズンアイテム':   { tags: ['ハンディファン', '充電式カイロ'], label: 'シーズンアイテム', children: ['ハンディファン', '充電式カイロ'] },
      'ハンディファン':     { tags: ['ハンディファン'],                 label: 'ハンディファン',     parent: 'シーズンアイテム' },
      '充電式カイロ':       { tags: ['充電式カイロ'],                   label: '充電式カイロ',       parent: 'シーズンアイテム' },
      'スーツケース':       { tags: ['スーツケース'],                   label: 'スーツケース' },
      'トラベルアイテム':   { tags: ['トラベルアイテム'],               label: 'トラベルアイテム',   parent: 'スーツケース' },
      'ビューティーアイテム': { tags: ['ビューティーアイテム'],         label: 'ビューティーアイテム' },
    };

    const PRICE_PRESETS = {
      'under3000':    { min: 0,     max: 3000,    label: '¥3,000以下' },
      '3000to10000':  { min: 3000,  max: 10000,   label: '¥3,000〜¥10,000' },
      '10000to30000': { min: 10000, max: 30000,   label: '¥10,000〜¥30,000' },
      'over30000':    { min: 30000, max: 9999999, label: '¥30,000以上' },
    };

    const TAG_PARAM = 'filter.p.tag'; // Shopifyのタグフィルターパラメーター名

    let panel    = null;
    let overlay  = null;
    let closeBtn = null;

    // ── URLから現在のタグ一覧を取得 ──────────────────
    function getActiveTags() {
      return new URLSearchParams(window.location.search).getAll(TAG_PARAM);
    }

    // ── URLから選択中のカテゴリープリセット名を取得 ──
    function getSelectedCategoryPresets() {
      return new URLSearchParams(window.location.search).getAll('category_preset');
    }

    function getSelectedPresets() {
      return new URLSearchParams(window.location.search).getAll('price_preset');
    }

    // ── カテゴリーチェックボックスの復元 ──────────────
    function restoreCategoryChecks() {
      const selected = getSelectedCategoryPresets();
      if (selected.length === 0) return;
      document.querySelectorAll('.filter-panel__category-check').forEach((cb) => {
        const label = cb.dataset.label;
        if (selected.includes(label)) {
          cb.checked = true;
        }
      });
      // 親がチェックされていれば子のindeterminate表示（任意）
      syncParentChildState();
    }

    // ── 親子チェック状態の同期 ───────────────────────
    // 親チェック → 子を全チェック / 子の一部チェック → 親をindeterminate
    function syncParentChildState() {
      document.querySelectorAll('.filter-panel__category-check:not(.filter-panel__category-child)').forEach((parentCb) => {
        const preset = CATEGORY_PRESETS[parentCb.dataset.label];
        if (!preset || !preset.children) return;

        const childCbs = Array.from(
          document.querySelectorAll(`.filter-panel__category-child[data-parent="${parentCb.dataset.label}"]`)
        );
        if (childCbs.length === 0) return;

        const checkedCount = childCbs.filter(c => c.checked).length;
        if (parentCb.checked) {
          // 親がチェックされたら子も全チェック
          childCbs.forEach(c => { c.checked = true; });
        } else if (checkedCount > 0 && checkedCount < childCbs.length) {
          parentCb.indeterminate = true;
        } else if (checkedCount === childCbs.length && checkedCount > 0) {
          parentCb.checked = true;
          childCbs.forEach(c => { c.checked = true; });
        }
      });
    }

    // ── フォーム送信時にカテゴリーhidden inputを生成 ──
    function buildCategoryHiddens(form) {
      form.querySelectorAll('input[data-category-hidden]').forEach(el => el.remove());

      const checkedCbs = Array.from(form.querySelectorAll('.filter-panel__category-check:checked'));
      if (checkedCbs.length === 0) return;

      // 送信するタグを収集（重複なし）
      const tagsToSend  = new Set();
      const labelsToSend = new Set();

      checkedCbs.forEach(cb => {
        const label  = cb.dataset.label;
        const preset = CATEGORY_PRESETS[label];
        if (!preset) return;

        // 子カテゴリーの場合、親もチェックされていればスキップ（親側でまとめて処理）
        if (preset.parent) {
          const parentCb = form.querySelector(`.filter-panel__category-check[data-label="${preset.parent}"]`);
          if (parentCb && parentCb.checked) return; // 親チェック済みなら子は個別処理不要
        }

        labelsToSend.add(label);
        preset.tags.forEach(t => tagsToSend.add(t));
      });

      // category_preset hidden を追加
      labelsToSend.forEach(label => {
        const h = document.createElement('input');
        h.type  = 'hidden';
        h.name  = 'category_preset';
        h.value = label;
        h.dataset.categoryHidden = '1';
        form.appendChild(h);
      });

      // filter.p.tag hidden を追加
      tagsToSend.forEach(tag => {
        const h = document.createElement('input');
        h.type  = 'hidden';
        h.name  = TAG_PARAM;
        h.value = tag;
        h.dataset.categoryHidden = '1';
        form.appendChild(h);
      });
    }

    // ── カテゴリーアクティブタグを描画 ───────────────
    function renderCategoryTags() {
      const selected  = getSelectedCategoryPresets();
      const container = document.getElementById('ActiveFilters');
      if (!container) return;

      // 既存のカテゴリータグを削除
      container.querySelectorAll('.active-filters__item--category').forEach(el => el.remove());
      if (selected.length === 0) return;

      selected.forEach((presetLabel) => {
        const preset = CATEGORY_PRESETS[presetLabel];
        if (!preset) return;

        // このプリセットを除いた状態のURLを生成
        const removeParams = new URLSearchParams(window.location.search);

        // category_preset から当該ラベルを除去
        removeParams.delete('category_preset');
        const remaining = selected.filter(v => v !== presetLabel);
        remaining.forEach(v => removeParams.append('category_preset', v));

        // filter.p.tag からこのプリセットのタグを除去し、残りのタグを再設定
        removeParams.delete(TAG_PARAM);

        // 残るプリセットのタグを収集
        const remainingTags = new Set();
        remaining.forEach(v => {
          const p = CATEGORY_PRESETS[v];
          if (p) p.tags.forEach(t => remainingTags.add(t));
        });
        // URLに既存の（カテゴリー以外の）タグも保持
        getActiveTags().forEach(t => {
          // 削除対象プリセットのタグは除外、残るプリセットのタグは保持
          const isInRemovedPreset = preset.tags.includes(t);
          if (!isInRemovedPreset || remainingTags.has(t)) {
            remainingTags.add(t);
          }
        });
        remainingTags.forEach(t => removeParams.append(TAG_PARAM, t));

        const removeUrl = window.location.pathname + '?' + removeParams.toString();

        const li = document.createElement('li');
        li.className = 'active-filters__item active-filters__item--category';
        li.innerHTML = `
          <span class="active-filters__label">${preset.label}</span>
          <a href="${removeUrl}" class="active-filters__remove" aria-label="${preset.label}を解除">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true">
              <line x1="1" y1="1" x2="7" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="7" y1="1" x2="1" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </a>`;
        container.appendChild(li);
      });

      // active-filters--empty クラスの制御
      updateActiveFiltersVisibility();
    }

    function updateActiveFiltersVisibility() {
      const container = document.getElementById('ActiveFilters');
      if (!container) return;
      if (container.children.length > 0) {
        container.classList.remove('active-filters--empty');
      } else {
        container.classList.add('active-filters--empty');
      }
    }

    function fixAllRemoveLinks() {
      const currentParams = new URLSearchParams(window.location.search);
      const pricePresets    = currentParams.getAll('price_preset');
      const categoryPresets = currentParams.getAll('category_preset');
      const activeTags      = currentParams.getAll(TAG_PARAM);
      const minInput        = document.getElementById('FilterPriceMin');
      const maxInput        = document.getElementById('FilterPriceMax');

      // カラー・その他フィルターの×ボタン：price_preset と category_preset + filter.p.tag を引き継ぐ
      document.querySelectorAll(
        '.active-filters__item:not(.active-filters__item--price):not(.active-filters__item--category) .active-filters__remove'
      ).forEach((link) => {
        const url = new URL(link.href);
        if (pricePresets.length > 0) {
          url.searchParams.delete('price_preset');
          pricePresets.forEach(v => url.searchParams.append('price_preset', v));
          if (minInput && minInput.value) url.searchParams.set(minInput.name, minInput.value);
          if (maxInput && maxInput.value) url.searchParams.set(maxInput.name, maxInput.value);
        }
        if (categoryPresets.length > 0) {
          url.searchParams.delete('category_preset');
          categoryPresets.forEach(v => url.searchParams.append('category_preset', v));
          url.searchParams.delete(TAG_PARAM);
          activeTags.forEach(t => url.searchParams.append(TAG_PARAM, t));
        }
        link.href = url.toString();
      });

      document.querySelectorAll(
        '.active-filters__item--price .active-filters__remove'
      ).forEach((link) => {
        const url = new URL(link.href);
        currentParams.forEach((value, key) => {
          if (key === 'price_preset') return;
          if (key === (minInput && minInput.name)) return;
          if (key === (maxInput && maxInput.name)) return;
          if (!url.searchParams.has(key)) {
            url.searchParams.append(key, value);
          }
        });
        link.href = url.toString();
      });
    }

    // コレクションハンドル → 自動チェックするカテゴリーラベルのマップ
    const COLLECTION_CATEGORY_MAP = {
      'suitcase':     'スーツケース',
      'beauty-goods': 'ビューティーアイテム',
      'handy-fan':    'ハンディファン',
      'warmer':       '充電式カイロ',
      'season-item':  'シーズンアイテム',
      'goods':  'トラベルアイテム',
    };

    // 現在のコレクションハンドルを取得（/collections/xxx の xxx 部分）
    function getCurrentCollectionHandle() {
      const match = window.location.pathname.match(/^\/collections\/([^\/]+)/);
      return match ? match[1] : null;
    }

    // コレクションページにいる場合、該当カテゴリーを自動チェック
    function autoCheckCategoryFromCollection() {
      const handle = getCurrentCollectionHandle();
      if (!handle || handle === 'all') return;

      // URLにすでにcategory_presetがある場合はスキップ（手動選択を優先）
      if (getSelectedCategoryPresets().length > 0) return;

      const categoryLabel = COLLECTION_CATEGORY_MAP[handle];
      if (!categoryLabel) return;

      document.querySelectorAll('.filter-panel__category-check').forEach((cb) => {
        if (cb.dataset.label === categoryLabel) {
          cb.checked = true;
        }
      });
      syncParentChildState();
    }

    function init() {
      panel    = document.getElementById(PANEL_ID);
      overlay  = document.getElementById(OVERLAY_ID);
      closeBtn = document.getElementById(CLOSE_BTN_ID);
      if (!panel) return;

      restoreCategoryChecks();
      autoCheckCategoryFromCollection();
      restorePriceChecks();
      syncPriceInputsFromChecks();
      renderCategoryTags();
      renderPriceTags();
      fixAllRemoveLinks();
      initPriceCheckboxes();
      initCategoryCheckboxes();
      initSortSelect();

      // フォーム送信時の処理
      const filterForm = document.getElementById(FORM_ID);
      if (filterForm) {
        filterForm.addEventListener('submit', function() {
          // カテゴリー hidden input を生成
          buildCategoryHiddens(filterForm);

          // カラーの active_color hidden input を生成
          filterForm.querySelectorAll('input[name="active_color"]').forEach(el => el.remove());
          const checkedColors = Array.from(
            filterForm.querySelectorAll('.filter-panel__color-checkbox:checked')
          );
          checkedColors.forEach(cb => {
            const hidden = document.createElement('input');
            hidden.type  = 'hidden';
            hidden.name  = 'active_color';
            hidden.value = cb.dataset.colorName || cb.value;
            filterForm.appendChild(hidden);
          });
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    }

    function restorePriceChecks() {
      const selected = getSelectedPresets();
      if (selected.length === 0) return;
      document.querySelectorAll('.filter-panel__price-check').forEach((cb) => {
        cb.checked = selected.includes(cb.value);
      });
    }

    function syncPriceInputsFromChecks() {
      const checked  = Array.from(document.querySelectorAll('.filter-panel__price-check:checked'));
      const priceMin = document.getElementById('FilterPriceMin');
      const priceMax = document.getElementById('FilterPriceMax');
      const form     = document.getElementById(FORM_ID);

      if (form) {
        form.querySelectorAll('input[name="price_preset"][type="hidden"]').forEach(el => el.remove());
      }

      if (checked.length === 0) {
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        return;
      }

      const mins   = checked.map(cb => parseInt(cb.dataset.priceMin, 10));
      const maxes  = checked.map(cb => parseInt(cb.dataset.priceMax, 10));
      const selMin = Math.min(...mins);
      const selMax = Math.max(...maxes);

      if (priceMin) priceMin.value = selMin === 0 ? '' : selMin;
      if (priceMax) priceMax.value = selMax >= 9999999 ? '' : selMax;

      if (form) {
        checked.forEach(cb => {
          const hidden = document.createElement('input');
          hidden.type  = 'hidden';
          hidden.name  = 'price_preset';
          hidden.value = cb.value;
          form.appendChild(hidden);
        });
      }
    }

    function renderPriceTags() {
      const selected  = getSelectedPresets();
      const container = document.getElementById('ActiveFilters');
      if (!container) return;

      container.querySelectorAll('.active-filters__item--price').forEach(el => el.remove());
      if (selected.length === 0) {
        updateActiveFiltersVisibility();
        return;
      }

      const minInput = document.getElementById('FilterPriceMin');
      const maxInput = document.getElementById('FilterPriceMax');

      selected.forEach((presetValue) => {
        const preset = PRICE_PRESETS[presetValue];
        if (!preset) return;

        const removeParams = new URLSearchParams(window.location.search);
        removeParams.delete('price_preset');
        const remaining = selected.filter(v => v !== presetValue);
        remaining.forEach(v => removeParams.append('price_preset', v));

        if (remaining.length > 0) {
          const mins   = remaining.map(v => PRICE_PRESETS[v]?.min ?? 0);
          const maxes  = remaining.map(v => PRICE_PRESETS[v]?.max ?? 9999999);
          const newMin = Math.min(...mins);
          const newMax = Math.max(...maxes);
          if (minInput) {
            newMin === 0
              ? removeParams.delete(minInput.name)
              : removeParams.set(minInput.name, newMin);
          }
          if (maxInput) {
            newMax >= 9999999
              ? removeParams.delete(maxInput.name)
              : removeParams.set(maxInput.name, newMax);
          }
        } else {
          if (minInput) removeParams.delete(minInput.name);
          if (maxInput) removeParams.delete(maxInput.name);
        }

        const removeUrl = window.location.pathname + '?' + removeParams.toString();

        const li = document.createElement('li');
        li.className = 'active-filters__item active-filters__item--price';
        li.innerHTML = `
          <span class="active-filters__label">${preset.label}</span>
          <a href="${removeUrl}" class="active-filters__remove" aria-label="${preset.label}を解除">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true">
              <line x1="1" y1="1" x2="7" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="7" y1="1" x2="1" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </a>`;
        container.appendChild(li);
      });

      updateActiveFiltersVisibility();
    }

    function updateBadgeCount(pricePresetCount) {
      const triggerBtn = document.querySelector('.collection-filter-trigger');
      if (!triggerBtn) return;
      const existingBadge = triggerBtn.querySelector('.filter-trigger__badge');
      if (existingBadge) existingBadge.remove();
    }

    function initPriceCheckboxes() {
      document.querySelectorAll('.filter-panel__price-check').forEach((cb) => {
        cb.addEventListener('change', syncPriceInputsFromChecks);
      });
    }

    function initCategoryCheckboxes() {
      // 親チェック → 子を連動
      document.querySelectorAll('.filter-panel__category-check:not(.filter-panel__category-child)').forEach((parentCb) => {
        const preset = CATEGORY_PRESETS[parentCb.dataset.label];
        if (!preset || !preset.children) return;

        parentCb.addEventListener('change', () => {
          const childCbs = document.querySelectorAll(
            `.filter-panel__category-child[data-parent="${parentCb.dataset.label}"]`
          );
          childCbs.forEach(c => { c.checked = parentCb.checked; });
          parentCb.indeterminate = false;
        });
      });

      // 子チェック → 親を連動
      document.querySelectorAll('.filter-panel__category-child').forEach((childCb) => {
        childCb.addEventListener('change', () => {
          const parentLabel = childCb.dataset.parent;
          if (!parentLabel) return;
          const parentCb = document.querySelector(
            `.filter-panel__category-check[data-label="${parentLabel}"]`
          );
          if (!parentCb) return;
          const allChildren = Array.from(
            document.querySelectorAll(`.filter-panel__category-child[data-parent="${parentLabel}"]`)
          );
          const checkedCount = allChildren.filter(c => c.checked).length;
          if (checkedCount === 0) {
            parentCb.checked = false;
            parentCb.indeterminate = false;
          } else if (checkedCount === allChildren.length) {
            parentCb.checked = true;
            parentCb.indeterminate = false;
          } else {
            parentCb.checked = false;
            parentCb.indeterminate = true;
          }
        });
      });
    }

    function initSortSelect() {
      const sortSelect = document.getElementById('CollectionSortBy');
      if (!sortSelect) return;
      sortSelect.addEventListener('change', () => {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort_by', sortSelect.value);
        currentParams.delete('page');
        window.location.href = window.location.pathname + '?' + currentParams.toString();
      });
    }

    function open() {
      if (!panel) return;
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      panel.classList.add(OPEN_CLASS);
      overlay.classList.add(OPEN_CLASS);
      document.body.classList.add(BODY_CLASS);
      if (closeBtn) {
        closeBtn.setAttribute('aria-hidden', 'false');
        closeBtn.classList.add(OPEN_CLASS);
      }
      const firstFocusable = panel.querySelector('input, a[href]');
      if (firstFocusable) setTimeout(() => firstFocusable.focus(), 50);
    }

    function close() {
      if (!panel) return;
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      panel.classList.remove(OPEN_CLASS);
      overlay.classList.remove(OPEN_CLASS);
      document.body.classList.remove(BODY_CLASS);
      if (closeBtn) {
        closeBtn.setAttribute('aria-hidden', 'true');
        closeBtn.classList.remove(OPEN_CLASS);
      }
    }

    init();
    return { open, close };
  })();








  // グローバルに公開（onclick属性から呼び出すため）
  window.CardColorSwatch = CardColorSwatch;
  window.FilterPanel = FilterPanel;


  // judge.me レビューテキストを統一フォーマットに上書き
  function fixJudgeMeText() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function(el) {
      const badge = el.closest('[data-number-of-reviews]');
      if (!badge) return;
      const count = badge.getAttribute('data-number-of-reviews') || '0';
      const formatted = '(' + count + ')';
      // すでに正しい形式なら何もしない（無限ループ防止）
      if (el.textContent === formatted) return;
      el.textContent = formatted;
    });
  }

  // 初回実行
  fixJudgeMeText();

  // 動的コンテンツ用：変更監視（テキストノードの変更は無視）
  const jdgmObserver = new MutationObserver(function(mutations) {
    const hasRelevant = mutations.some(m =>
      Array.from(m.addedNodes).some(n =>
        n.nodeType === 1 && (
          n.classList?.contains('jdgm-prev-badge') ||
          n.querySelector?.('.jdgm-prev-badge')
        )
      )
    );
    if (hasRelevant) fixJudgeMeText();
  });
  jdgmObserver.observe(document.body, { childList: true, subtree: true });





  ////////////////////////////////////
  // 商品詳細
  ////////////////////////////////////
  //********************** */
  // アコーディオン
  //********************** */
  $('.product_accordions .head').on('click', function() {
    // クリックされた要素にクラス 'is-active' を付与/削除
    $(this).toggleClass('is-active');
    
    // クリックされた要素の直後の .body をスライド開閉
    $(this).next('.body').slideToggle(300);
  });



  ////////////////////////////////////
  // 商品詳細：存在しない組み合わせを選択した場合の自動フォールバック（デバッグ版）
  ////////////////////////////////////
  (function () {
    document.addEventListener('change', function (e) {
      const target = e.target;
      if (!(target.matches && target.matches('variant-selects fieldset input[type="radio"]'))) return;

      const container = target.closest('variant-selects');
      if (!container) return;

      const stickyBtn = document.getElementById('lbt-sticky-btn');
      const productData = stickyBtn ? $(stickyBtn).data('productJson') : null;
      if (!productData || !productData.variants) return;

      const variants = productData.variants;

      const selectedMap = {};
      container.querySelectorAll('fieldset input:checked').forEach((input) => {
        const position = input.name.split('-').pop().trim();
        selectedMap[position] = input.value;
      });

      const changedPosition = target.name.split('-').pop().trim();

      let colorPosition = null;
      productData.options.forEach((optionName, idx) => {
        const nameDown = optionName.toLowerCase().trim();
        if (nameDown === 'カラー' || nameDown === 'color' || nameDown === 'colour') {
          colorPosition = String(idx + 1);
        }
      });

      if (!colorPosition || changedPosition === colorPosition) return;

      const currentColorValue = selectedMap[colorPosition];
      const stillExists = variants.some((v) =>
        Object.keys(selectedMap).every((pos) => v['option' + pos] === selectedMap[pos])
      );
      if (stillExists) return;

      const fallback = variants.find(
        (v) => v['option' + changedPosition] === selectedMap[changedPosition]
      );
      if (!fallback) return;

      const fallbackColorValue = fallback['option' + colorPosition];
      if (fallbackColorValue === currentColorValue) return;

      // 生のname属性に改行が含まれるため、CSSセレクタでの末尾一致は使わず
      // JS側で位置とvalueをtrimして比較しながら探す
      const candidateInputs = container.querySelectorAll('fieldset input[type="radio"]');
      let targetInput = null;
      candidateInputs.forEach((el) => {
        const pos = el.name.split('-').pop().trim();
        if (pos === colorPosition && el.value === fallbackColorValue) {
          targetInput = el;
        }
      });

      if (targetInput) targetInput.checked = true;
    }, true);
  })();








  //********************** */
  // 商品ギャラリー
  //********************** */
  if ($(".product_slider").length) {
    const product_swiper = new Swiper('.product_slider', {
      // slidesPerView: 1.2,
      slidesPerView: 1,
      // spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      effect: 'fade', 
      speed: 1500,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      // breakpoints: {
      //   1024: { spaceBetween: 30 },
      //   768:  { spaceBetween: 20 },
      // },
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  }


  //********************** */
  // カラーバリエーション選択時 サムネイル画像
  //********************** */
  // function overrideMediaGallery() {
  //   const MediaGalleryClass = customElements.get('media-gallery');
  //   if (!MediaGalleryClass) return;

  //   const proto = MediaGalleryClass.prototype;
  //   if (proto.__lbt_patched) return;
  //   proto.__lbt_patched = true;

  //   proto.setActiveMedia = function (mediaId, prepend) {
  //     if (!mediaId) return;
      
  //     // 1. 内部IDを更新（Dawn標準の必須処理）
  //     this.activeMediaId = mediaId;

  //     // 2. 対象のメディア要素を特定
  //     const targetMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
  //     if (!targetMedia) return;

  //     // 3. 全てのメディアから is-active クラスを外し、対象にだけ付与
  //     this.querySelectorAll('[data-media-id]').forEach((media) => {
  //       media.classList.remove('is-active');
  //     });
  //     targetMedia.classList.add('is-active');

  //     // 4. スライダーの移動処理
  //     const sliderComponent = this.querySelector('slider-component');
  //     const sliderList = this.querySelector('[id^="Slider-Gallery-"]');

  //     if (sliderComponent && sliderList) {
  //       const allSlides = Array.from(sliderList.querySelectorAll('.slider__slide:not(.thumbnail-list__item)'));
  //       const targetSlide = targetMedia.closest('.slider__slide');
  //       const targetIndex = allSlides.indexOf(targetSlide);

  //       if (targetIndex !== -1) {
  //         const isPc = window.innerWidth >= 990;

  //         if (isPc) {
  //           // PC: scrollLeft で即時移動
  //           sliderList.style.scrollSnapType = 'none';
  //           sliderList.style.scrollBehavior = 'auto';
  //           sliderList.scrollLeft = targetSlide.offsetLeft;
  //           setTimeout(() => {
  //             sliderList.style.scrollSnapType = '';
  //             sliderList.style.scrollBehavior = '';
  //           }, 100);
  //         } else {
  //           // SP: Dawn標準のsetActivePage相当を直接呼ぶ
  //           const pageWidth = sliderList.querySelector('.slider__slide')?.offsetWidth || 0;
  //           if (pageWidth > 0) {
  //             sliderList.style.scrollBehavior = 'auto';
  //             sliderList.scrollLeft = pageWidth * targetIndex;
  //             setTimeout(() => {
  //               sliderList.style.scrollBehavior = '';
  //             }, 100);
  //           }
  //         }
  //       }
  //       // if (targetIndex !== -1) {
  //       //   requestAnimationFrame(() => {
  //       //     requestAnimationFrame(() => {
  //       //       sliderList.style.scrollSnapType = 'none';
  //       //       sliderList.style.scrollBehavior = 'auto';
  //       //       sliderList.scrollLeft = targetSlide.offsetLeft;

  //       //       this.__lbt_snapResetTimer = setTimeout(() => {
  //       //         sliderList.style.scrollSnapType = '';
  //       //         sliderList.style.scrollBehavior = '';
  //       //         this.__lbt_snapResetTimer = null;
  //       //       }, 100);
  //       //     });
  //       //   });
  //       // }
  //     }

  //     // 5. サムネイルの更新 と 【位置調整（スクロール）】
  //     const sectionId = this.getAttribute('data-section') || this.id.replace('MediaGallery-', '');
  //     const thumbContainer = document.getElementById(`GalleryThumbnails-${sectionId}`);
      
  //     if (thumbContainer) {
  //       const thumbnails = thumbContainer.querySelectorAll('button.thumbnail');
  //       const thumbList = thumbContainer.querySelector('.thumbnail-list'); // サムネイルのリストコンテナ

  //       thumbnails.forEach(btn => {
  //         const parent = btn.closest('[data-target]');
  //         const isActive = parent && parent.dataset.target === mediaId;
  //         btn.setAttribute('aria-current', isActive ? 'true' : 'false');

  //         // --- ★追加：アクティブなサムネイルの位置を調整 ---
  //         if (isActive && thumbList) {
  //           // 親コンテナ（thumbList）に対するサムネイル（parent）の相対位置を計算
  //           const isPc = window.innerWidth >= 990; // Dawnのブレイクポイント（PC）

  //           if (isPc) {
  //             // PC: 縦スクロール。アクティブなサムネイルがリストの一番上に来るようにスクロール
  //             const targetTop = parent.offsetTop;
  //             thumbList.scrollTo({
  //               top: targetTop,
  //               behavior: 'smooth'
  //             });
  //           } else {
  //             // SP: 横スクロール。アクティブなサムネイルがリストの一番左に来るようにスクロール
  //             const targetLeft = parent.offsetLeft;
  //             thumbList.scrollTo({
  //               left: targetLeft,
  //               behavior: 'smooth'
  //             });
  //           }
  //         }
  //         // --------------------------------------------------
  //       });
  //     }

  //   };
  // }


  // ver20260902
  //********************** */
  // カラーバリエーション選択時 サムネイル画像
  //********************** */
  // サムネイルの aria-current 更新 と 位置調整（スクロール）
  // setActiveMedia（クリック時）と、ページ初期表示時（?variant=直リンク対応）の両方から呼ぶ
  function scrollThumbnailIntoView(thumbContainer, mediaId, instant) {
    if (!thumbContainer || !mediaId) return;

    const thumbnails = thumbContainer.querySelectorAll('button.thumbnail');
    const thumbList = thumbContainer.querySelector('.thumbnail-list');
    if (!thumbList) return;

    thumbnails.forEach((btn) => {
      const parent = btn.closest('[data-target]');
      const isActive = parent && parent.dataset.target === mediaId;
      btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (!isActive || !parent) return;

      const listRect = thumbList.getBoundingClientRect();
      const itemRect = parent.getBoundingClientRect();

      // 実際にオーバーフローしている軸を判定してスクロール
      // （PC/SPの幅で決め打ちせず、実測でどちら向きに動かせばよいか判定する）
      const canScrollVertically   = thumbList.scrollHeight > thumbList.clientHeight + 1;
      const canScrollHorizontally = thumbList.scrollWidth  > thumbList.clientWidth  + 1;
      const behavior = instant ? 'auto' : 'smooth'; // 初期表示時はアニメーションなしで即座に合わせる

      if (canScrollVertically && !canScrollHorizontally) {
        thumbList.scrollTo({ top: thumbList.scrollTop + (itemRect.top - listRect.top), behavior });
      } else if (canScrollHorizontally) {
        thumbList.scrollTo({ left: thumbList.scrollLeft + (itemRect.left - listRect.left), behavior });
      }
    });
  }

  function overrideMediaGallery() {
    const MediaGalleryClass = customElements.get('media-gallery');
    if (!MediaGalleryClass) return;

    const proto = MediaGalleryClass.prototype;
    if (proto.__lbt_patched) return;
    proto.__lbt_patched = true;

    proto.setActiveMedia = function (mediaId, prepend) {
      if (!mediaId) return;

      // 連続でバリエーションを切り替えた際、古い呼び出しの遅延処理（scroll-snap再有効化）が
      // 新しい呼び出しの位置を巻き戻してしまわないよう、呼び出しごとに世代番号を持たせて防ぐ
      this.__lbt_callToken = (this.__lbt_callToken || 0) + 1;
      const callToken = this.__lbt_callToken;

      // 1. 内部IDを更新（Dawn標準の必須処理）
      this.activeMediaId = mediaId;

      // 2. 対象のメディア要素を特定
      const targetMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!targetMedia) return;

      // 3. 全てのメディアから is-active クラスを外し、対象にだけ付与
      this.querySelectorAll('[data-media-id]').forEach((media) => {
        media.classList.remove('is-active');
      });
      targetMedia.classList.add('is-active');

      // 4. メインスライダーの移動処理（同期的に即時移動。PC/SP共通）
      const sliderList = this.querySelector('[id^="Slider-Gallery-"]');
      const targetSlide = targetMedia.closest('.slider__slide');

      if (sliderList && targetSlide) {
        sliderList.style.scrollSnapType = 'none';
        sliderList.style.scrollBehavior = 'auto';
        sliderList.scrollLeft = targetSlide.offsetLeft;

        setTimeout(() => {
          if (this.__lbt_callToken !== callToken) return; // より新しい呼び出しが来ていたら何もしない
          sliderList.style.scrollSnapType = '';
          sliderList.style.scrollBehavior = '';
        }, 100);
      }

      // 5. サムネイルの更新 と 位置調整（スクロール）
      const sectionId = this.getAttribute('data-section') || this.id.replace('MediaGallery-', '');
      const thumbContainer = document.getElementById(`GalleryThumbnails-${sectionId}`);
      scrollThumbnailIntoView(thumbContainer, mediaId, false);
    };
  }

  
  
  function syncHeight(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;
    function update() {
      if (window.innerWidth < 990) return;
      const h = viewer.getBoundingClientRect().height;
      if (h > 0) gallery.style.setProperty('--lbt-gallery-h', h + 'px');
    }
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(viewer);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }
 
  function init() {
    overrideMediaGallery();
    document.querySelectorAll('media-gallery').forEach(syncHeight);

    // ver20260902
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const activeMedia = gallery.querySelector('[data-media-id].is-active');
      if (!activeMedia) return;
      const mediaId = activeMedia.getAttribute('data-media-id');
      const sectionId = gallery.getAttribute('data-section') || gallery.id.replace('MediaGallery-', '');
      const thumbContainer = document.getElementById(`GalleryThumbnails-${sectionId}`);

      // レイアウト確定後に実行（画像読み込み等でthumbListの高さ/幅が
      // まだ確定していないタイミングを避けるため）
      requestAnimationFrame(() => {
        scrollThumbnailIntoView(thumbContainer, mediaId, true);
      });
    });


  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }





  /* =========================================================================
   LBT Sticky ATC + Quick Add Popup (TOP・商品詳細 共通完全統合版)
   ========================================================================= */
  
  let currentActiveProduct = null; // 現在ポップアップが保持している商品のJSONデータ
  let selectedOptions = [];        // 現在選択中のオプション値の配列 ['アッシュグレー', 'Sサイズ']

  // ── 1. イベントリスナー定義（各種トリガーの検知） ──────────────────────────
  
  // A. TOPページや商品カード（card-product.liquid）からのトリガー
  $(document).on('click', '.lbt-trigger-quick-add', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const productData = $(this).data('productJson');
    const variantMeta = $(this).data('variantMeta');
    if (productData) {
      if (variantMeta) {
        productData.variantMeta = variantMeta;
      }
      openQuickPopup(productData, false);
    }
  });




  // B. 商品詳細ページの固定カート（Sticky ATC）からのトリガー
  // $(document).on('click', '#lbt-sticky-btn', function (e) {
  //   e.preventDefault();
    
  //   // レンタルスーツケースの場合はEasifyオプション部分へスムーズスクロール（既存ロジックを継承）
  //   if (this.dataset.isRental === 'true') {
  //     const easifyTarget = document.querySelector('.easify-product-options');
  //     if (easifyTarget) {
  //       const offset = 80; // ヘッダー等の被り考慮
  //       const top = easifyTarget.getBoundingClientRect().top + window.scrollY - offset;
  //       window.scrollTo({ top: top, behavior: 'smooth' });
  //     }
  //     return;
  //   }

  //   // 通常商品の場合はポップアップを展開
  //   const productData = $(this).data('productJson');
  //   if (productData) {
  //     openQuickPopup(productData, true); // 商品詳細からの発火
  //   }
  // });





// $(document).on('click', '#lbt-sticky-btn', function (e) {
//   e.preventDefault();

//   // 実際にEasifyのオプション項目(.po-option-root)が存在するかで判定
//   const easifyOptionItems = document.querySelectorAll('.easify-product-options .po-option-root');

//   if (easifyOptionItems.length > 0) {
//     // スクロール先はオプション全体の入れ物(.easify-product-options)
//     const scrollTarget = document.querySelector('.easify-product-options');
//     const offset = 80;
//     const top = scrollTarget.getBoundingClientRect().top + window.scrollY - offset;
//     window.scrollTo({ top: top, behavior: 'smooth' });
//     return;s
//   }

//   // オプションがない通常商品の場合はポップアップを展開
//   const productData = $(this).data('productJson');
//   if (productData) {
//     openQuickPopup(productData, true);
//   }
// });
$(document).on('click', '#lbt-sticky-btn', function (e) {
  e.preventDefault();

  const RENTAL_TAG = 'レンタルスーツケース';
  const productData = $(this).data('productJson');

  // ① 商品データが存在し、tags（配列または文字列）に「レンタルスーツケース」が含まれている
  const isRentalSuitcase = !!productData && (
    Array.isArray(productData.tags)
      ? productData.tags.includes(RENTAL_TAG)
      : typeof productData.tags === 'string' &&
        productData.tags.split(',').map(t => t.trim()).includes(RENTAL_TAG)
  );

  // ② 実際にEasifyのオプション項目(.po-option-root)が存在する
  //    ※Easifyはアプリ側で後から描画されるため、クリック時点で毎回判定する
  const hasEasifyOptions =
    document.querySelectorAll('.easify-product-options .po-option-root').length > 0;

  // ①または②ならページ内スクロール（クイックポップアップは開かない）
  if (isRentalSuitcase || hasEasifyOptions) {
    const dateInput = document.querySelector('.rental-arrival__input');

    // 到着希望日が入力済みなら、メインの購入ボタンを押したのと同じ動作にする
    if (dateInput && dateInput.value && dateInput.form) {
      const form = dateInput.form;
      const addBtn = form.querySelector('[type="submit"][name="add"]');
      if (addBtn) {
        addBtn.click();
      } else {
        form.requestSubmit();
      }
      return;
    }

    // スクロール先：到着希望日の欄を優先し、なければEasifyのオプション欄
    const scrollTarget =
      document.querySelector('.rental-arrival') ||
      document.querySelector('.easify-product-options');

    if (scrollTarget) {
      const offset = 80;
      const top = scrollTarget.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (dateInput) {
        setTimeout(function () { dateInput.focus({ preventScroll: true }); }, 400);
      }
    }
    return;
  }

  // どちらにも当てはまらない通常商品の場合はポップアップを展開
  if (productData) {
    openQuickPopup(productData, true);
  }
});



  // ── 2. ポップアップ展開コアロジック ─────────────────────────────────────
  function openQuickPopup(product, isProductPage = false) {
    if (!product.variantMeta) {
      const popupData = window.LBT_POPUP_DATA?.[product.id];
      if (popupData?.variantMeta) {
        product.variantMeta = popupData.variantMeta;
      }
    }

    currentActiveProduct = product;

    const initialVariant = product.variants.find(v => v.available) || product.variants[0];
    
    selectedOptions = [];
    for (let i = 0; i < product.options.length; i++) {
      selectedOptions.push(initialVariant['option' + (i + 1)] || '');
    }

    $('#lbt-popup-title').text(product.title);
    $('#lbt-qty-input').val(1);
    $('#lbt-popup-msg').text('');
    $('#lbt-popup-stock-status').text('').css('color', '');

    renderPopupOptionsStructure(product);
    updatePopupVariantDOM(isProductPage);

    const $popup = $('#lbt-quick-popup');
    $popup.attr('aria-hidden', 'false').addClass('is-open');
    $('body').css('overflow', 'hidden').addClass('lbt-popup-open');
    
    const $closeBtn = $('#lbt-popup-close');
    if ($closeBtn.length) $closeBtn.focus();
  }





  // 指定したオプション位置(optionIdx)に値(val)を仮定した場合、
  // 他の「現在選択中」オプションとの組み合わせで実在するバリアントがあるか判定
  function combinationExists(product, optionIdx, val, currentSelected) {
    return product.variants.some(v => {
      for (let i = 0; i < currentSelected.length; i++) {
        if (i === optionIdx) {
          if (v['option' + (i + 1)] !== val) return false;
        } else if (currentSelected[i]) {
          if (v['option' + (i + 1)] !== currentSelected[i]) return false;
        }
      }
      return true;
    });
  }

  // ── 3. オプションUI（カラースウォッチ / 通常ボタン）の動的レンダリング ──────────
  function renderPopupOptionsStructure(product) {
    const $container = $('#lbt-popup-options-container');
    $container.empty();

    if (!product.options || product.options.length === 0) return;

    product.options.forEach((optionName, optionIdx) => {
      // 該当の option 位置（option1, option2, option3）に存在するユニークな値を抽出
      const optKey = 'option' + (optionIdx + 1);
      const values = [...new Set(product.variants.map(v => v[optKey]))].filter(Boolean);

      // const optionNameDown = optionName.toLowerCase();
      // const isColor = optionNameDown.includes('color') || optionNameDown.includes('colour') || optionNameDown.includes('カラー') || optionNameDown.includes('色');

      const optionNameDown = optionName.toLowerCase().trim();
      // 本体カラーのみをスウォッチにするための厳密な判定
      // オプション名が「カラー」「color」「colour」のいずれかに完全一致、または特定の文字列のみを対象にする
      const isColor = (optionNameDown === 'カラー' || optionNameDown === 'color' || optionNameDown === 'colour');

      const $optionWrap = $('<div class="lbt-quick-popup__option"></div>').attr('data-option-index', optionIdx);
      
      if (isColor) {
        // A. カラーパターンの場合：スウォッチ型UIを生成
        $optionWrap.append(`<p class="lbt-quick-popup__option-label">${escapeHtml(optionName)}：<span class="lbt-selected-val">${escapeHtml(selectedOptions[optionIdx])}</span></p>`);
        const $swatches = $('<div class="lbt-quick-popup__swatches"></div>');

        values.forEach(val => {
          if (!combinationExists(product, optionIdx, val, selectedOptions)) return; // 存在しなければ描画しない

          const matchVariant = product.variants.find(v => v[optKey] === val);
          const imgUrl = (matchVariant && matchVariant.featured_image) ? matchVariant.featured_image.src : '';
          const isActive = (selectedOptions[optionIdx] === val) ? ' is-active' : '';

          const $btn = $(`
            <button type="button" class="lbt-swatch${isActive}" data-value="${escapeHtml(val)}" data-option-index="${optionIdx}" data-img="${escapeHtml(imgUrl)}" aria-label="${escapeHtml(val)}" title="${escapeHtml(val)}">
              <span class="lbt-swatch__inner"></span>
            </button>
          `);

          // 【既存ロジック完全継承】Dawn標準のスウォッチの背景色（--swatch--background）をDOMから検索して吸い上げる
          let swatchBg = '';
          const existingLabel = document.querySelector(`.swatch-input__label[title="${val}"]`);
          if (existingLabel) {
            const existingSwatch = existingLabel.querySelector('.swatch');
            if (existingSwatch) {
              swatchBg = existingSwatch.style.getPropertyValue('--swatch--background').trim();
            }
          }

          // 2. もし取得できなければ（TOPページなど）、前半の CardColorSwatch 内で定義されたルール等から色を補完、または暫定カラーマップ
          if (!swatchBg) {
            // ローカルでも簡易的に引けるように、主要カラーのカラーマップをフォールバックとして用意
            const popupColorMap = {
              'ブラック': '#000000', 'マットブラック': '#111111', 'アルミニウムブラック': '#000', 'クラシックブラック': '#000000',
              'ホワイト': '#ffffff', 'マットホワイト': '#fff', 'エナメルホワイト': '#ffffff', 'アイボリーホワイト': '#fff',
              'シルバー': '#D3D3D3', 'アルミニウムシルバー': '#999A9E', 'エナメルシルバー': '#E7E8EA', 'マットシルバー': '#B4BABE', 'クラシックシルバー': '#E6E7EA',
              'グレー': '#D3D3D3', 'マットグレー': '#818183', 'スモーキーグレー': '#6C6C6F', 'ダークグレー': '#4C4C4E', 'アッシュグレー': '#504E4E',
              'ピンク': '#FFC0CB', 'エナメルピンク': '#DBB6B3', 'コーラルピンク': '#ED9088',
              'ブルー': '#CAE4E6', 'エナメルスカイブルー': '#93A2C3', 'スカイブルー': '#CAE4E6',
              'カーキ': '#2f3640', 'エナメルカーキ': '#9EBBB1', 'オリーブ': '#C6CFC1',
              'パープル': '#C3ACCA', 'ラベンダーパープル': '#CDC2D5',
              'ブラウン': '#9A5630', 'サンドベージュ': '#DBC7B2', 'ベージュ': '#EAD8AB'
            };
            swatchBg = popupColorMap[val] || popupColorMap[val.trim()];
          }

          // 3. 背景色をスウォッチに適用
          if (swatchBg) {
            $btn.find('.lbt-swatch__inner').css('background-color', swatchBg);
          }




          $swatches.append($btn);
        });
        $optionWrap.append($swatches);

      } else {
        // B. サイズやその他の属性の場合：通常の矩形ボタン型UIを生成
        $optionWrap.append(`<p class="lbt-quick-popup__option-label">${escapeHtml(optionName)}</p>`);
        const $btnsWrap = $('<div class="lbt-quick-popup__option-btns"></div>');

        values.forEach(val => {
          // if (!combinationExists(product, optionIdx, val, selectedOptions)) return; // 存在しなければ描画しない

          const isActive = (selectedOptions[optionIdx] === val) ? ' is-active' : '';
          const $btn = $(`
            <button type="button" class="lbt-option-btn${isActive}" data-value="${escapeHtml(val)}" data-option-index="${optionIdx}">
              ${escapeHtml(val)}
            </button>
          `);
          $btnsWrap.append($btn);
        });
        $optionWrap.append($btnsWrap);
      }

      $container.append($optionWrap);
    });
  }


  // ── 4. オプション変更時のクリックインターセプション ──────────────────────
  // $(document).on('click', '.lbt-swatch, .lbt-option-btn', function (e) {
  //   e.preventDefault();
  //   const $btn = $(this);
  //   const optIdx = parseInt($btn.attr('data-option-index'), 10);
  //   const val = $btn.attr('data-value');

  //   // 選択された値を配列に格納
  //   selectedOptions[optIdx] = val;

  //   // クラスのアクティブ制御
  //   $btn.siblings().removeClass('is-active');
  //   $btn.addClass('is-active');

  //   // カラーラベルのテキスト同期
  //   $btn.closest('.lbt-quick-popup__option').find('.lbt-selected-val').text(val);

  //   // 画像と価格、ボタン状態を新バリアントに追従
  //   const isProductPage = $('#lbt-sticky-atc').hasClass('is-visible') || window.location.pathname.includes('/products/');
  //   updatePopupVariantDOM(isProductPage);
  // });



  // $(document).on('click', '.lbt-swatch, .lbt-option-btn', function (e) {
  //   e.preventDefault();
  //   const $btn = $(this);
  //   const optIdx = parseInt($btn.attr('data-option-index'), 10);
  //   const val = $btn.attr('data-value');

  //   selectedOptions[optIdx] = val;

  //   // 存在しない組み合わせを除外した状態で選択肢UI全体を再描画
  //   renderPopupOptionsStructure(currentActiveProduct);

  //   const isProductPage = $('#lbt-sticky-atc').hasClass('is-visible') || window.location.pathname.includes('/products/');
  //   updatePopupVariantDOM(isProductPage);
  // });


  $(document).on('click', '.lbt-swatch, .lbt-option-btn', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const optIdx = parseInt($btn.attr('data-option-index'), 10);
    const val = $btn.attr('data-value');

    selectedOptions[optIdx] = val;

    const product = currentActiveProduct;
    if (product) {
      // 色以外のオプション（サイズ等）を変更した場合、選択中のカラーが
      // 新しい組み合わせでも存在するか確認し、存在しなければ
      // そのオプション内で最初に存在するカラーへ自動的に切り替える
      product.options.forEach((optionName, colorIdx) => {
        if (colorIdx === optIdx) return; // 自分自身（今クリックした軸）はスキップ

        const nameDown = optionName.toLowerCase().trim();
        const isColor = (nameDown === 'カラー' || nameDown === 'color' || nameDown === 'colour');
        if (!isColor) return; // カラー以外の軸は対象外

        const currentColorVal = selectedOptions[colorIdx];
        if (currentColorVal && combinationExists(product, colorIdx, currentColorVal, selectedOptions)) {
          return; // 現在のカラーのままで組み合わせが存在するので変更不要
        }

        // 存在しない場合、このカラー軸で購入可能な最初の値に差し替える
        const colorKey = 'option' + (colorIdx + 1);
        const candidateValues = [...new Set(product.variants.map(v => v[colorKey]))].filter(Boolean);
        const fallbackVal = candidateValues.find(v => combinationExists(product, colorIdx, v, selectedOptions));
        if (fallbackVal) {
          selectedOptions[colorIdx] = fallbackVal;
        }
      });
    }

    // 存在しない組み合わせを除外した状態で選択肢UI全体を再描画
    renderPopupOptionsStructure(currentActiveProduct);

    const isProductPage = $('#lbt-sticky-atc').hasClass('is-visible') || window.location.pathname.includes('/products/');
    updatePopupVariantDOM(isProductPage);
  });


  // ── 5. バリアント判定とDOMマッピング（画像、価格、カートボタン） ────────────────
  function updatePopupVariantDOM(isProductPage = false) {
    if (!currentActiveProduct) return;

    const currentVariant = currentActiveProduct.variants.find(v => {
      return selectedOptions.every((val, i) => v['option' + (i + 1)] === val);
    });

    const $atcBtn = $('#lbt-popup-atc-btn');
    const $popupImg = $('#lbt-popup-img');
    const $stockStatus = $('#lbt-popup-stock-status');

    if (currentVariant) {
      const priceText = Shopify?.formatMoney
        ? Shopify.formatMoney(currentVariant.price, window.theme?.moneyFormat || '¥')
        : '¥' + (currentVariant.price / 100).toLocaleString();

      $('#lbt-popup-price').html(`${priceText}<span class="small">税込</span>`);
      
      if (isProductPage) {
        const stickyPrice = document.getElementById('lbt-sticky-price');
        if (stickyPrice) stickyPrice.textContent = priceText;
      }

      if (currentVariant.featured_image && currentVariant.featured_image.src) {
        const optimizedSrc = currentVariant.featured_image.src.replace(/(\.[^.]+)$/, '_400x400$1');
        $popupImg.attr('src', optimizedSrc);
      } else if (currentActiveProduct.featured_image) {
        $popupImg.attr('src', currentActiveProduct.featured_image);
      } else {
        const $activeSwatch = $('.lbt-swatch.is-active');
        if ($activeSwatch.length && $activeSwatch.attr('data-img')) {
          $popupImg.attr('src', $activeSwatch.attr('data-img'));
        }
      }

      const variantMeta = currentActiveProduct.variantMeta || {};
      const meta = variantMeta[String(currentVariant.id)] || {};
      const stockStatus = meta.stock_status || '在庫あり';
      const restockDesc = meta.restock_desc || '';

      if (stockStatus === '在庫なし') {
        $stockStatus.text('売り切れ').css('color', '#999');
        $atcBtn.prop('disabled', true).text('売り切れ').addClass('disabled');
        $atcBtn.data('variantId', null);

      } else if (stockStatus === 'お取り寄せ') {
        const desc = restockDesc || '入荷日未定';
        $stockStatus.text('お取り寄せ：' + desc).css('color', '#555');
        $atcBtn.prop('disabled', false).text('カートに入れる').removeClass('disabled');
        $atcBtn.data('variantId', currentVariant.id);

      } else if (stockStatus === '先行予約注文') {
        const desc = restockDesc || '入荷日未定';
        $stockStatus.text('先行予約注文：' + desc).css('color', '#555');
        $atcBtn.prop('disabled', false).text('カートに入れる').removeClass('disabled');
        $atcBtn.data('variantId', currentVariant.id);

      } else if (stockStatus === '入荷待ち') {
        const desc = restockDesc || '入荷日未定';
        $stockStatus.text('入荷待ち：' + desc).css('color', '#555');
        $atcBtn.prop('disabled', true).text('入荷待ち').addClass('disabled');
        $atcBtn.data('variantId', null);

      } else {
        $stockStatus.text('2〜3営業日以内に発送いたします。').css('color', '#555');
        if (currentVariant.available) {
          $atcBtn.prop('disabled', false).text('カートに入れる').removeClass('disabled');
          $atcBtn.data('variantId', currentVariant.id);
        } else {
          $atcBtn.prop('disabled', true).text('売り切れ').addClass('disabled');
          $atcBtn.data('variantId', null);
        }
      }

    } else {
      $stockStatus.text('').css('color', '');
      $atcBtn.prop('disabled', true).text('選択できません').addClass('disabled');
      $atcBtn.data('variantId', null);
    }
  }



  

  // ── 6. 数量セレクターロジック ──────────────────────────────────────────
  $(document).on('click', '#lbt-qty-minus', function () {
    const $input = $('#lbt-qty-input');
    const val = parseInt($input.val(), 10) || 1;
    if (val > 1) $input.val(val - 1);
  });

  $(document).on('click', '#lbt-qty-plus', function () {
    const $input = $('#lbt-qty-input');
    const val = parseInt($input.val(), 10) || 1;
    if (val < 99) $input.val(val + 1);
  });


  // ── 7. カート追加（Ajax処理・Easifyプロパティ自動収集・遷移制御） ───────────────
  $(document).on('click', '#lbt-popup-atc-btn', function (e) {
    e.preventDefault();
    const variantId = $(this).data('variantId');
    const quantity = parseInt($('#lbt-qty-input').val(), 10) || 1;
    const $msg = $('#lbt-popup-msg');
    const $atcBtn = $(this);

    if (!variantId) return;

    $atcBtn.prop('disabled', true).text('追加中…');
    $msg.css('color', '#555').text('');

    // 【既存ロジック完全移植】Easifyのカスタム属性（レンタル用日付など）をDOMからディープスキャンして収集
    const easifyProperties = {};
    const mainForm = document.querySelector('form[action="/cart/add"]');
    if (mainForm) {
      mainForm.querySelectorAll('input[name^="properties["]').forEach(input => {
        const key = input.name.match(/properties\[(.+)\]/)?.[1];
        if (key && input.value) easifyProperties[key] = input.value;
      });
      mainForm.querySelectorAll('select[name^="properties["]').forEach(select => {
        const key = select.name.match(/properties\[(.+)\]/)?.[1];
        if (key && select.value) easifyProperties[key] = select.value;
      });
      mainForm.querySelectorAll('textarea[name^="properties["]').forEach(textarea => {
        const key = textarea.name.match(/properties\[(.+)\]/)?.[1];
        if (key && textarea.value) easifyProperties[key] = textarea.value;
      });
    }

    // Shopify Cart API への非同期POST
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity,
        properties: easifyProperties
      },
      dataType: 'json',
      success: function (cart) {
        // カート追加成功後の遷移ロジック（既存に倣い /cart へダイレクト遷移）
        window.location.href = '/cart';
      },
      error: function (xhr, textStatus, errorThrown) {
        $msg.css('color', '#b31717').text('エラーが発生しました。もう一度お試しください。');
        $atcBtn.prop('disabled', false).text('カートに入れる');
      }
    });
  });


  // ── 8. クローズ（閉じる）アニメーション・トリガー ─────────────────────────────
  function closeQuickPopup() {
    const $popup = $('#lbt-quick-popup');
    $popup.attr('aria-hidden', 'true').removeClass('is-open');
    $('body').css('overflow', '').removeClass('lbt-popup-open');
    currentActiveProduct = null;
  }

  $(document).on('click', '#lbt-popup-close, #lbt-popup-overlay', function (e) {
    e.preventDefault();
    closeQuickPopup();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('#lbt-quick-popup').hasClass('is-open')) {
      closeQuickPopup();
    }
  });


  // ── 9. 商品詳細ページ：固定カートバーのスクロール表示・非表示監視 ────────────────────
  const originalAtcBtn = document.querySelector('.product-form__submit');
  const footerElement = document.querySelector('footer, .footer, #shopify-section-footer');
  const stickyBar = document.getElementById('lbt-sticky-atc');

  function updateStickyVisibility() {
    if (!originalAtcBtn || !stickyBar) return;

    const atcRect = originalAtcBtn.getBoundingClientRect();
    const atcPassed = atcRect.bottom < 0; // 元のボタンが画面上部に消え去ったか
    
    let footerReached = false;
    if (footerElement) {
      const footerRect = footerElement.getBoundingClientRect();
      footerReached = footerRect.top < window.innerHeight; // フッターが画面内に入ってきたか
    }

    if (atcPassed && !footerReached) {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  if (originalAtcBtn && stickyBar) {
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    updateStickyVisibility(); // 初期実行
  }

  // HTMLエスケープ処理安全弁
  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }




  ////////////////////////////////////
  // 比較表スクロールヒント
  ////////////////////////////////////
  if ($(".js-scrollable").length && typeof ScrollHint !== 'undefined') {
    new ScrollHint('.js-scrollable', {
      suggestiveShadow: true,
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  }

});